import { InfraNodeStatus } from "./components/InfraNode";

export class InfraUtils
{
    static getNodeStatus(node: { id: string, last_seen_at: Date | null }, onlines: (string | null)[])
    {
        if (!node.last_seen_at)
            return { title: InfraNodeStatus.NeverConnected, color: "gray" };

        if (onlines.includes(node.id))
            return { title: InfraNodeStatus.Online, color: "green" };

        return { title: InfraNodeStatus.NotOnline, color: "red" }
    }
}